import { Component, OnInit } from '@angular/core'; 
import { HttpClient,HttpHeaders,HttpRequest, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as bootstrap from "bootstrap";
import * as $AB from 'jquery';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';
import Cookies from 'js-cookie'; 
import { DatePipe } from '@angular/common';
import Tagify from '@yaireo/tagify';

 declare var $: any;

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.css'],
  providers: [DatePipe]
})
export class AssetComponent implements OnInit {
    key:any="gau98187rav87752";
    token:any;
    success:any;
    error:any;
    shortdescription:any;
    associationList = [];
    selectedassociation = [];
    associationSettings = {};

    dropdownList = [];
    selectedItems = [];
    dropdownSettings = {};

    sourceList=[];
    selectedsource=[];
    sourceSettings={};
    public imagePath;
    imgSrc:any="./assets/image/bc.png";
    modal:any;
     item=['Medical'];
      territory_data=['India'];
    shortdesclength:any=0;

    type_s3path:any;
    type_s4path:any;
    type_s5path:any;
    type_s6path:any;
    type_s7path:any;
    type_s8path:any;
    date:any=new Date();
   constructor(private router: Router,private http:HttpClient, private datePipe: DatePipe) { }


  ngOnInit(): void {
// after API working please remove lines of code below this comment
  // if(!Cookies.get('tData')){
  //     this.router.navigate(['/']);
  //   }
  //   else{
  //   this.token=CryptoJS.AES.decrypt(Cookies.get('tData'), this.key).toString(CryptoJS.enc.Utf8);
  //   }
      $('#long_desc').summernote();
      $('#data_lineage').summernote();
    var tagify = new Tagify(document.querySelector('input[name=territory]'), {
    delimiters : null,
    templates : {
        tag : function(v, tagData){
            try{
            return `<tag title='${v}' contenteditable='false' spellcheck="false" class='tagify__tag ${tagData.class ? tagData.class : ""}' ${this.getAttributes(tagData)}>
                        <x title='remove tag' class='tagify__tag__removeBtn'></x>
                        <div>
                            ${tagData.code ?
                            `<img onerror="this.style.visibility = 'hidden'" src='https://lipis.github.io/flag-icon-css/flags/4x3/${tagData.code.toLowerCase()}.svg'>` : ''
                            }
                            <span class='tagify__tag-text'>${v}</span>
                        </div>
                    </tag>`
            }
            catch(err){}
        },

        dropdownItem : function(tagData){
            try{
            return `<div class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}'>
                            <img onerror="this.style.visibility = 'hidden'"
                                 src='https://lipis.github.io/flag-icon-css/flags/4x3/${tagData.code.toLowerCase()}.svg'>
                            <span>${tagData.value}</span>
                        </div>`
            }
            catch(err){}
        }
    },
    enforceWhitelist : true,
    whitelist : [
      { value:'Afghanistan', code:'AF' },
      { value:'Åland Islands', code:'AX' },
      { value:'Albania', code:'AL' },
      { value:'Algeria', code:'DZ' },
      { value:'American Samoa', code:'AS' },
      { value:'Andorra', code:'AD' },
      { value:'Angola', code:'AO' },
      { value:'Anguilla', code:'AI' },
      { value:'Antarctica', code:'AQ' },
      { value:'Antigua and Barbuda', code:'AG' },
      { value:'Argentina', code:'AR' },
      { value:'Armenia', code:'AM' },
      { value:'Aruba', code:'AW' },
      { value:'Australia', code:'AU', searchBy:'beach, sub-tropical' },
      { value:'Austria', code:'AT' },
      { value:'Azerbaijan', code:'AZ' },
      { value:'Bahamas', code:'BS' },
      { value:'Bahrain', code:'BH' },
      { value:'Bangladesh', code:'BD' },
      { value:'Barbados', code:'BB' },
      { value:'Belarus', code:'BY' },
      { value:'Belgium', code:'BE' },
      { value:'Belize', code:'BZ' },
      { value:'Benin', code:'BJ' },
      { value:'Bermuda', code:'BM' },
      { value:'Bhutan', code:'BT' },
      { value:'Bolivia', code:'BO' },
      { value:'Bosnia and Herzegovina', code:'BA' },
      { value:'Botswana', code:'BW' },
      { value:'Bouvet Island', code:'BV' },
      { value:'Brazil', code:'BR' },
      { value:'British Indian Ocean Territory', code:'IO' },
      { value:'Brunei Darussalam', code:'BN' },
      { value:'Bulgaria', code:'BG' },
      { value:'Burkina Faso', code:'BF' },
      { value:'Burundi', code:'BI' },
      { value:'Cambodia', code:'KH' },
      { value:'Cameroon', code:'CM' },
      { value:'Canada', code:'CA' },
      { value:'Cape Verde', code:'CV' },
      { value:'Cayman Islands', code:'KY' },
      { value:'Central African Republic', code:'CF' },
      { value:'Chad', code:'TD' },
      { value:'Chile', code:'CL' },
      { value:'China', code:'CN' },
      { value:'Christmas Island', code:'CX' },
      { value:'Cocos (Keeling) Islands', code:'CC' },
      { value:'Colombia', code:'CO' },
      { value:'Comoros', code:'KM' },
      { value:'Congo', code:'CG' },
      { value:'Congo, The Democratic Republic of the', code:'CD' },
      { value:'Cook Islands', code:'CK' },
      { value:'Costa Rica', code:'CR' },
      { value:'Cote D\'Ivoire', code:'CI' },
      { value:'Croatia', code:'HR' },
      { value:'Cuba', code:'CU' },
      { value:'Cyprus', code:'CY' },
      { value:'Czech Republic', code:'CZ' },
      { value:'Denmark', code:'DK' },
      { value:'Djibouti', code:'DJ' },
      { value:'Dominica', code:'DM' },
      { value:'Dominican Republic', code:'DO' },
      { value:'Ecuador', code:'EC' },
      { value:'Egypt', code:'EG' },
      { value:'El Salvador', code:'SV' },
      { value:'Equatorial Guinea', code:'GQ' },
      { value:'Eritrea', code:'ER' },
      { value:'Estonia', code:'EE' },
      { value:'Ethiopia', code:'ET' },
      { value:'Falkland Islands (Malvinas)', code:'FK' },
      { value:'Faroe Islands', code:'FO' },
      { value:'Fiji', code:'FJ' },
      { value:'Finland', code:'FI' },
      { value:'France', code:'FR' },
      { value:'French Guiana', code:'GF' },
      { value:'French Polynesia', code:'PF' },
      { value:'French Southern Territories', code:'TF' },
      { value:'Gabon', code:'GA' },
      { value:'Gambia', code:'GM' },
      { value:'Georgia', code:'GE' },
      { value:'Germany', code:'DE' },
      { value:'Ghana', code:'GH' },
      { value:'Gibraltar', code:'GI' },
      { value:'Greece', code:'GR' },
      { value:'Greenland', code:'GL' },
      { value:'Grenada', code:'GD' },
      { value:'Guadeloupe', code:'GP' },
      { value:'Guam', code:'GU' },
      { value:'Guatemala', code:'GT' },
      { value:'Guernsey', code:'GG' },
      { value:'Guinea', code:'GN' },
      { value:'Guinea-Bissau', code:'GW' },
      { value:'Guyana', code:'GY' },
      { value:'Haiti', code:'HT' },
      { value:'Heard Island and Mcdonald Islands', code:'HM' },
      { value:'Holy See (Vatican City State)', code:'VA' },
      { value:'Honduras', code:'HN' },
      { value:'Hong Kong', code:'HK' },
      { value:'Hungary', code:'HU' },
      { value:'Iceland', code:'IS' },
      { value:'India', code:'IN' },
      { value:'Indonesia', code:'ID' },
      { value:'Iran, Islamic Republic Of', code:'IR' },
      { value:'Iraq', code:'IQ' },
      { value:'Ireland', code:'IE' },
      { value:'Isle of Man', code:'IM' },
      { value:'Israel', code:'IL', searchBy:'holy land, desert' },
      { value:'Italy', code:'IT' },
      { value:'Jamaica', code:'JM' },
      { value:'Japan', code:'JP' },
      { value:'Jersey', code:'JE' },
      { value:'Jordan', code:'JO' },
      { value:'Kazakhstan', code:'KZ' },
      { value:'Kenya', code:'KE' },
      { value:'Kiribati', code:'KI' },
      { value:'Korea, Democratic People\'S Republic of', code:'KP' },
      { value:'Korea, Republic of', code:'KR' },
      { value:'Kuwait', code:'KW' },
      { value:'Kyrgyzstan', code:'KG' },
      { value:'Lao People\'S Democratic Republic', code:'LA' },
      { value:'Latvia', code:'LV' },
      { value:'Lebanon', code:'LB' },
      { value:'Lesotho', code:'LS' },
      { value:'Liberia', code:'LR' },
      { value:'Libyan Arab Jamahiriya', code:'LY' },
      { value:'Liechtenstein', code:'LI' },
      { value:'Lithuania', code:'LT' },
      { value:'Luxembourg', code:'LU' },
      { value:'Macao', code:'MO' },
      { value:'Macedonia, The Former Yugoslav Republic of', code:'MK' },
      { value:'Madagascar', code:'MG' },
      { value:'Malawi', code:'MW' },
      { value:'Malaysia', code:'MY' },
      { value:'Maldives', code:'MV' },
      { value:'Mali', code:'ML' },
      { value:'Malta', code:'MT' },
      { value:'Marshall Islands', code:'MH' },
      { value:'Martinique', code:'MQ' },
      { value:'Mauritania', code:'MR' },
      { value:'Mauritius', code:'MU' },
      { value:'Mayotte', code:'YT' },
      { value:'Mexico', code:'MX' },
      { value:'Micronesia, Federated States of', code:'FM' },
      { value:'Moldova, Republic of', code:'MD' },
      { value:'Monaco', code:'MC' },
      { value:'Mongolia', code:'MN' },
      { value:'Montserrat', code:'MS' },
      { value:'Morocco', code:'MA' },
      { value:'Mozambique', code:'MZ' },
      { value:'Myanmar', code:'MM' },
      { value:'Namibia', code:'NA' },
      { value:'Nauru', code:'NR' },
      { value:'Nepal', code:'NP' },
      { value:'Netherlands', code:'NL' },
      { value:'Netherlands Antilles', code:'AN' },
      { value:'New Caledonia', code:'NC' },
      { value:'New Zealand', code:'NZ' },
      { value:'Nicaragua', code:'NI' },
      { value:'Niger', code:'NE' },
      { value:'Nigeria', code:'NG' },
      { value:'Niue', code:'NU' },
      { value:'Norfolk Island', code:'NF' },
      { value:'Northern Mariana Islands', code:'MP' },
      { value:'Norway', code:'NO' },
      { value:'Oman', code:'OM' },
      { value:'Pakistan', code:'PK' },
      { value:'Palau', code:'PW' },
      { value:'Palestinian Territory, Occupied', code:'PS' },
      { value:'Panama', code:'PA' },
      { value:'Papua New Guinea', code:'PG' },
      { value:'Paraguay', code:'PY' },
      { value:'Peru', code:'PE' },
      { value:'Philippines', code:'PH' },
      { value:'Pitcairn', code:'PN' },
      { value:'Poland', code:'PL' },
      { value:'Portugal', code:'PT' },
      { value:'Puerto Rico', code:'PR' },
      { value:'Qatar', code:'QA' },
      { value:'Reunion', code:'RE' },
      { value:'Romania', code:'RO' },
      { value:'Russian Federation', code:'RU' },
      { value:'RWANDA', code:'RW' },
      { value:'Saint Helena', code:'SH' },
      { value:'Saint Kitts and Nevis', code:'KN' },
      { value:'Saint Lucia', code:'LC' },
      { value:'Saint Pierre and Miquelon', code:'PM' },
      { value:'Saint Vincent and the Grenadines', code:'VC' },
      { value:'Samoa', code:'WS' },
      { value:'San Marino', code:'SM' },
      { value:'Sao Tome and Principe', code:'ST' },
      { value:'Saudi Arabia', code:'SA' },
      { value:'Senegal', code:'SN' },
      { value:'Serbia and Montenegro', code:'CS' },
      { value:'Seychelles', code:'SC' },
      { value:'Sierra Leone', code:'SL' },
      { value:'Singapore', code:'SG' },
      { value:'Slovakia', code:'SK' },
      { value:'Slovenia', code:'SI' },
      { value:'Solomon Islands', code:'SB' },
      { value:'Somalia', code:'SO' },
      { value:'South Africa', code:'ZA' },
      { value:'South Georgia and the South Sandwich Islands', code:'GS' },
      { value:'Spain', code:'ES' },
      { value:'Sri Lanka', code:'LK' },
      { value:'Sudan', code:'SD' },
      { value:'Suriname', code:'SR' },
      { value:'Svalbard and Jan Mayen', code:'SJ' },
      { value:'Swaziland', code:'SZ' },
      { value:'Sweden', code:'SE' },
      { value:'Switzerland', code:'CH' },
      { value:'Syrian Arab Republic', code:'SY' },
      { value:'Taiwan, Province of China', code:'TW' },
      { value:'Tajikistan', code:'TJ' },
      { value:'Tanzania, United Republic of', code:'TZ' },
      { value:'Thailand', code:'TH' },
      { value:'Timor-Leste', code:'TL' },
      { value:'Togo', code:'TG' },
      { value:'Tokelau', code:'TK' },
      { value:'Tonga', code:'TO' },
      { value:'Trinidad and Tobago', code:'TT' },
      { value:'Tunisia', code:'TN' },
      { value:'Turkey', code:'TR' },
      { value:'Turkmenistan', code:'TM' },
      { value:'Turks and Caicos Islands', code:'TC' },
      { value:'Tuvalu', code:'TV' },
      { value:'Uganda', code:'UG' },
      { value:'Ukraine', code:'UA' },
      { value:'United Arab Emirates', code:'AE' },
      { value:'United Kingdom', code:'GB' },
      { value:'United States', code:'US' },
      { value:'United States Minor Outlying Islands', code:'UM' },
      { value:'Uruguay', code:'UY' },
      { value:'Uzbekistan', code:'UZ' },
      { value:'Vanuatu', code:'VU' },
      { value:'Venezuela', code:'VE' },
      { value:'Viet Nam', code:'VN' },
      { value:'Virgin Islands, British', code:'VG' },
      { value:'Virgin Islands, U.S.', code:'VI' },
      { value:'Wallis and Futuna', code:'WF' },
      { value:'Western Sahara', code:'EH' },
      { value:'Yemen', code:'YE' },
      { value:'Zambia', code:'ZM' },
      { value:'Zimbabwe', code:'ZW' }
    ],
    dropdown : {
        enabled: 1,
        classname : 'extra-properties'
    }
})

tagify.addTags(tagify.settings.whitelist.slice(100,101));

var keywords = document.querySelector('input[name=keywords]'),
    tagify = new Tagify(keywords, {
        pattern             : /^.{0,20}$/, 
        delimiters          : ",| ",        // add new tags when a comma or a space character is entered
        keepInvalidTags     : true,         // do not remove invalid tags (but keep them marked as invalid)
        editTags            : 1,            // single click to edit a tag
        maxTags             : 6,
        transformTag        : transformTag,
        backspace           : "edit",
        placeholder         : "Enter smart tags",
        dropdown : {
            enabled: 3,
        }
    })

function getRandomColor(){
    function rand(min, max) {
        return min + Math.random() * (max - min);
    }

    var h = rand(1, 360)|0,
        s = rand(40, 70)|0,
        l = rand(65, 72)|0;

    return 'hsl(' + h + ',' + s + '%,' + l + '%)';
}

function transformTag( tagData ){
    tagData.style = "--tag-bg:" + getRandomColor();

    if( tagData.value.toLowerCase() == 'shit' )
       tagData.value = 's✲✲t'
}



  $(document).ready(function(){
    $('.sell').addClass('active');
    $('.sell a').css('color','#fff');
    $('.sell img').attr('src','./assets/image/icon/Sell.png');
    $(".ng2-tag-input").addClass("border-0");
    $(".ng2-tag-input").css('padding-left','10px');
    $(".ng2-tag-input__text-input").css('background-color','#f2f5f6');
    $("#data_transformed").click(function(){
    $(".dataset_id_verify").removeClass('d-none');
    });
    $("#data_raw").click(function(){
    $(".dataset_id_verify").addClass('d-none');
    });

     $("#incremental").click(function(){
    $("#incremental_type").removeClass('d-none');
    });
    $("#one-time").click(function(){
    $("#incremental_type").addClass('d-none');
    });

     $(".data_flow_api").click(function(){
    $(".url_schema").removeClass('d-none');
    });
    $(".data_flow_files").click(function(){
    $(".url_schema").addClass('d-none');
    });

    $("#extended_type").click(function(){
    $(".warranty_type").removeClass('d-none');
    });
    $("#one_month_type").click(function(){
    $(".warranty_type").addClass('d-none');
    });

    $(".regular_ltype").click(function(){
     if($(this).prop('checked')==true)
     {
       $(".regular_ltype_cost").removeClass('d-none');
     }
      if($(this).prop('checked')==false)
     {
       $(".regular_ltype_cost").addClass('d-none');
     }
    });
    $(".extended_ltype").click(function(){
     if($(this).prop('checked')==true)
     {
       $(".extended_ltype_cost").removeClass('d-none');
     }
      if($(this).prop('checked')==false)
     {
       $(".extended_ltype_cost").addClass('d-none');
     }
    });
    $(".sextended_ltype").click(function(){
     if($(this).prop('checked')==true)
     {
       $(".sextended_ltype_cost").removeClass('d-none');
     }
      if($(this).prop('checked')==false)
     {
       $(".sextended_ltype_cost").addClass('d-none');
     }
    });

    $('.thumbnail-click').click(function(){
            $('#thumbnail').trigger('click');
        });

  });

  
   this.associationList = [
                        {"id":1,"itemName":"Quantity","value":"Quantity"},
                        {"id":2,"itemName":"Frequency","value":"Frequency"},
                        {"id":3,"itemName":"Format","value":"Format"},
                        {"id":4,"itemName":"Size","value":"Size"}
                      ];
    this.selectedassociation=[
                        {"id":1,"itemName":"Quantity","value":"Quantity"},
                        {"id":2,"itemName":"Frequency","value":"Frequency"},
    ]


    this.associationSettings = { 
                              singleSelection: false, 
                              text:"Entity Association",
                              selectAllText:'Select All',
                              unSelectAllText:'UnSelect All',
                              enableSearchFilter: true,
                              classes:"myclass custom-class"
                            }; 

   this.dropdownList = [
                        {"id":1,"itemName":"Marketplace","value":"Marketplace"},
                        {"id":2,"itemName":"Exchange","value":"Exchange"},
                        {"id":3,"itemName":"Storage & Management","value":"Storage & Management"},
                        {"id":4,"itemName":"Measurements & Analytics","value":"Measurements & Analytics"},
                        {"id":5,"itemName":"Compliances","value":"Compliances"},
                        {"id":6,"itemName":"Personalization","value":"Personalization"},
                        {"id":7,"itemName":"AI & Machine Learning","value":"AI & Machine Learning"},
                        {"id":8,"itemName":"Research","value":"Research"},
                        {"id":9,"itemName":"Other","value":"Other"}
                      ];
    this.selectedItems=[
                        {"id":1,"itemName":"Marketplace","value":"Marketplace"},
                        {"id":2,"itemName":"Exchange","value":"Exchange"},
    ]
    this.dropdownSettings = { 
                              singleSelection: false, 
                              text:"Obejctives",
                              selectAllText:'Select All',
                              unSelectAllText:'UnSelect All',
                              enableSearchFilter: true,
                              classes:"myclass custom-class"
                            }; 



   this.sourceList = [
                        {"id":1,"itemName":"Self-Owned Software",'value':'Self-Owned Software'},
                        {"id":2,"itemName":"Self-Owned Hardware or IOT", 'value':'Self-Owned Hardware'},
                        {"id":3,"itemName":"Third Party Owned Software", 'value':'Third Party Owned Software'},
                        {"id":4,"itemName":"Third Party Owned Hardware or IOT", 'value':'Third Party Owned Hardware'},
                        {"id":5,"itemName":"Other",'value':'Other'}
                      ];
    this.selectedsource=[
                       {"id":1,"itemName":"Self-Owned Software", 'value':'Self-Owned Software'},
                       {"id":5,"itemName":"other", 'value':'Other'}
    ]
    this.sourceSettings = { 
                              singleSelection: false, 
                              text:"Sources",
                              selectAllText:'Select All',
                              unSelectAllText:'UnSelect All',
                              enableSearchFilter: true,
                              classes:"myclass custom-class"
                            }; 
   for(var i=0;i<this.selectedassociation.length;i++){
       if(this.selectedassociation[i]['value']=='Quantity'){
          $("#Quantity").removeClass("d-none");
         }
         if(this.selectedassociation[i]['value']=='Frequency'){
          $("#Frequency").removeClass("d-none");
         }
         if(this.selectedassociation[i]['value']=='Format'){
          $("#Format").removeClass("d-none");
         }
         if(this.selectedassociation[i]['value']=='Size'){
          $("#Size").removeClass("d-none");
         }
   }
  }


    onClick(event){
       $(".uploadmodal").modal('show');
      }
    
    onClick1(event){
        $(".uploadmodal1").modal('show');
       }
    onClick2(event){
        $(".uploadmodal2").modal('show');
       }
    onClick3(event){
        $(".uploadmodal3").modal('show');
       }
    onClick4(event){
        $(".uploadmodal4").modal('show');
       }
    onClick5(event){
        $(".uploadmodal5").modal('show');
       }


        onItemSelect(item:any){
         if(item['value']=='Quantity'){
          $("#Quantity").removeClass("d-none");
         }
         if(item['value']=='Frequency'){
          $("#Frequency").removeClass("d-none");
         }
         if(item['value']=='Format'){
          $("#Format").removeClass("d-none");
         }
         if(item['value']=='Size'){
          $("#Size").removeClass("d-none");
         }
       }
        OnItemDeSelect(item:any){
         if(item['value']=='Quantity'){
          $("#Quantity").addClass("d-none");
         }
         if(item['value']=='Frequency'){
          $("#Frequency").addClass("d-none");
         }
         if(item['value']=='Format'){
          $("#Format").addClass("d-none");
         }
         if(item['value']=='Size'){
          $("#Size").addClass("d-none");
         }
       }
      onSelectAll(items: any){
          $("#Quantity").removeClass("d-none");
          $("#Frequency").removeClass("d-none");
          $("#Format").removeClass("d-none");
          $("#Size").removeClass("d-none");
       }
     onDeSelectAll(items: any){
          $("#Quantity").addClass("d-none");
          $("#Frequency").addClass("d-none");
          $("#Format").addClass("d-none");
          $("#Size").addClass("d-none");
     }

    imgFileSelected(files) {
        var reader = new FileReader();
       this.imagePath = files;
       reader.readAsDataURL(files[0]); 
       reader.onload = (event) => { 
       this.imgSrc = reader.result; 
        }
      }
     countChar(shortdescription){
         let length=shortdescription.value.length;
         if(length<=280)
         {
          this.shortdesclength=length;
         }
         if(length>280)
         {
           $(".shortdescription").val(shortdescription.value.substring(0, 280));
           this.shortdesclength=shortdescription.value.substring(0, 280).length;
         }  
       };
     
     smart_tagInfo(event){
        $(".smart_tagInfo").modal('show');
       }

     data_classificationInfo(event){
        $(".data_classificationInfo").modal('show');
       }

       data_typeInfo(event){
        $(".data_typeInfo").modal('show');
       }

       data_territoryInfo(event){
        $(".data_territoryInfo").modal('show');
       }

     powerInfo(event){
        $(".powerInfo").modal('show');
       }


     demoInfo(event){
        $(".demoInfo").modal('show');
       }
       metricesInfo(event){
        $(".metricesInfo").modal('show');
       }

       data_prodInfo(event){
        $(".data_prodInfo").modal('show');
       }

       data_objectiveInfo(event){
        $(".data_objectiveInfo").modal('show');
       }

       data_sourcingInfo(event){
        $(".data_sourcingInfo").modal('show');
       }

       data_licensetypeInfo(event){
        $(".data_licensetypeInfo").modal('show');
       }

       data_warrantyInfo(event){
        $(".data_warrantyInfo").modal('show');
       }

       data_certiInfo(event){
        $(".data_certiInfo").modal('show');
       }

       data_flowInfo(event){
        $(".data_flowInfo").modal('show');
       }

       data_freqInfo(event){
        $(".data_freqInfo").modal('show');
       }

       data_sizeInfo(event){
        $(".data_sizeInfo").modal('show');
       }

       data_dictInfo(event){
        $(".data_dictInfo").modal('show');
       }

       data_previewInfo(event){
        $(".data_previewInfo").modal('show');
       }

       data_datasetInfo(event){
        $(".data_datasetInfo").modal('show');
       }

       data_metadataInfo(event){
        $(".data_metadataInfo").modal('show');
       }
       associationInfo(event){
        $(".associationInfo").modal('show');
       }

   onSubmit(form:NgForm){
               var headers:HttpHeaders = new HttpHeaders();
                headers=headers.append('Content-Type', 'application/x-www-form-urlencoded');
                headers=headers.append('Authorization', 'token '+this.token);
               let body: HttpParams = new HttpParams();
                body = body.append('category', 'data');
                body = body.append('image_link', form.value.file);
                body = body.append('title', form.value.title);
                body = body.append('type', form.value.category);
                body = body.append('short_description',form.value.shortdescription );
                body = body.append('long_description', form.value.longdescription);
                body = body.append('keywords', (form.value.keywords).toString());
              this.http.post<any>('http://ec2-54-201-120-61.us-west-2.compute.amazonaws.com:8000/api/assets/',body,
                 {
                  headers:headers
                 }
                   ).subscribe(resp=>{
                   console.log("essentials working successful");
                   },error=>{
                console.log(error.error);
                console.log('error working');
                });
                $("#kt_user_edit_tab_1").removeClass("active");
                       $(".essentials").removeClass("active");
                       $("#kt_user_edit_tab_2").addClass("active");
                       $(".stamping").addClass("active");
                }

              path(event){
                $(".uploadmodal").modal("hide");
                setTimeout(function() {
                     $(".uploadpath").modal("show");
                 }, 300);
              }

              file_0(event){
                $(".uploadmodal").modal("hide");
                setTimeout(function() {
                     $(".uploadfile_0").modal("show");
                 }, 300);
              }
          
          
              path1(event){
                $(".uploadmodal1").modal("hide");
                setTimeout(function() {
                     $(".uploadpath1").modal("show");
                 }, 300);
              }
              file1(event){
                $(".uploadmodal1").modal("hide");
                setTimeout(function() {
                     $(".uploadfile1").modal("show");
                 }, 300);
              }
              path2(event){
                $(".uploadmodal2").modal("hide");
                setTimeout(function() {
                     $(".uploadpath2").modal("show");
                 }, 300);
              }
              file2(event){
                $(".uploadmodal2").modal("hide");
                setTimeout(function() {
                     $(".uploadfile2").modal("show");
                 }, 300);
              }
              path3(event){
                $(".uploadmodal3").modal("hide");
                setTimeout(function() {
                     $(".uploadpath3").modal("show");
                 }, 300);
              }

              storagepath3(event){
                $(".uploadmodal3").modal("hide");
                setTimeout(function() {
                     $(".uploadstoragepath3").modal("show");
                 }, 300);
              }

              file3(event){
                $(".uploadmodal3").modal("hide");
                setTimeout(function() {
                     $(".uploadfile3").modal("show");
                 }, 300);
              }          
              
              path4(event){
                $(".uploadmodal4").modal("hide");
                setTimeout(function() {
                     $(".uploadpath4").modal("show");
                 }, 300);
              }

              file4(event){
                $(".uploadmodal4").modal("hide");
                setTimeout(function() {
                     $(".uploadfile4").modal("show");
                 }, 300);
              }

               path5(event){
                $(".uploadmodal5").modal("hide");
                setTimeout(function() {
                     $(".uploadpath5").modal("show");
                 }, 300);
              }

              
              file5(event){
                $(".uploadmodal5").modal("hide");
                setTimeout(function() {
                     $(".uploadfile5").modal("show");
                 }, 300);
              }

              onSubmit_dts3path(form:NgForm){
                    this.type_s3path=form.value.s3_path;
                      $(".verification_utility").text(this.type_s3path);
                      }
              
              onSubmit_dts4path(form:NgForm){
                        this.type_s4path=form.value.s4_path;
                          $(".data_dictionary_fill").text(this.type_s4path);
                          }
              onSubmit_dts5path(form:NgForm){
                            this.type_s5path=form.value.s5_path;
                              $(".preview_file_fill").text(this.type_s5path);
                              }
              onSubmit_dts6path(form:NgForm){
                                this.type_s6path=form.value.s6_path;
                                  $(".add_dataset_fill").text(this.type_s6path);
                                  }
              onSubmit_dts7path(form:NgForm){
                                    this.type_s7path=form.value.s7_path;
                                      $(".add_metadata_fill").text(this.type_s7path);
                                      }
                  onSubmit_dts8path(form:NgForm){
                                    this.type_s8path=form.value.s8_path;
                                      $(".add_metadata_fill").text(this.type_s8path);
                                      }
                        
        onSubmit_tab2(form:NgForm){
                 var headers:HttpHeaders = new HttpHeaders();
                headers=headers.append('Content-Type', 'application/x-www-form-urlencoded');
                headers=headers.append('Authorization', 'token '+this.token);
               let body: HttpParams = new HttpParams();
                body = body.append('asset', '1');
                body = body.append('classification', form.value.data_class);
                body = body.append('type', form.value.data_type);
                body = body.append('verification_utility_link', this.type_s3path);
                body = body.append('dataset_id', form.value.dataset_id);
                body = body.append('territory',(form.value.territory).toString());
                body = body.append('production_period_start', this.datePipe.transform(form.value.start_date, 'yyyy-MM-dd'));
                body = body.append('production_period_end', this.datePipe.transform(form.value.end_date, 'yyyy-MM-dd'));
                console.log(form.value)
              this.http.post<any>('http://ec2-54-201-120-61.us-west-2.compute.amazonaws.com:8000/api/assets/stamping/',body,
                 {
                  headers:headers
                 }
                   ).subscribe(resp=>{
                    console.log("stamping working successful");
                   },error=>{
                console.log(error.error);
                console.log('stamping not working');
                });
                $("#kt_user_edit_tab_2").removeClass("active");
                $(".stamping").removeClass("active");
                $("#kt_user_edit_tab_3").addClass("active");
                $(".storage").addClass("active");
         }

         p1($event){

          $("#kt_user_edit_tab_2").removeClass("active");
                $(".stamping").removeClass("active");
                $("#kt_user_edit_tab_1").addClass("active");
                $(".essentials").addClass("active");

         }

         
         p2($event){

          $("#kt_user_edit_tab_3").removeClass("active");
                $(".storage").removeClass("active");
                $("#kt_user_edit_tab_2").addClass("active");
                $(".stamping").addClass("active");

         }

         
         p3($event){

          $("#kt_user_edit_tab_4").removeClass("active");
                $(".steward").removeClass("active");
                $("#kt_user_edit_tab_3").addClass("active");
                $(".storage").addClass("active");

         }

         
         p4($event){

          $("#kt_user_edit_tab_5").removeClass("active");
                $(".license").removeClass("active");
                $("#kt_user_edit_tab_4").addClass("active");
                $(".steward").addClass("active");

         }

                

                
        onSubmit_tab3(form:NgForm){
          var headers:HttpHeaders = new HttpHeaders();
         headers=headers.append('Content-Type', 'application/x-www-form-urlencoded');
         headers=headers.append('Authorization', 'token '+this.token);
        let body: HttpParams = new HttpParams();
         body = body.append('asset', '1');
         body = body.append('name', form.value.name);
         body = body.append('email', form.value.email);
         body = body.append('phone', form.value.phone);
         body = body.append('sec_name',form.value.sec_name );
         body = body.append('sec_email', form.value.sec_email);
         body = body.append('sec_phone',form.value.sec_phone);
         console.log(form.value)
       this.http.post<any>('http://ec2-54-201-120-61.us-west-2.compute.amazonaws.com:8000/api/assets/steward/',body,
          {
           headers:headers
          }
            ).subscribe(resp=>{
             console.log("steward working successful");
            },error=>{
         console.log(error.error);
         console.log('steward not working');
         });
         $("#kt_user_edit_tab_4").removeClass("active");
                $(".steward").removeClass("active");
                $("#kt_user_edit_tab_5").addClass("active");
                $(".license").addClass("active");

                
         }


         onSubmit_tab4(form:NgForm){
          var headers:HttpHeaders = new HttpHeaders();
         headers=headers.append('Content-Type', 'application/x-www-form-urlencoded');
         headers=headers.append('Authorization', 'token '+this.token);
        let body: HttpParams = new HttpParams();
         body = body.append('asset', '1');
         body = body.append('flow', form.value.data_flow);
         body = body.append('frequency', form.value.data_freq);
         body = body.append('incremental_frequency_value', form.value.incremental_type);
         body = body.append('format', form.value.data_format);
         body = body.append('size',form.value.data_size );
         body = body.append('data_dictionary_link', this.type_s4path);
         body = body.append('preview_link', this.type_s5path);
         console.log(this.type_s5path);
         body = body.append('dataset_link', this.type_s6path);
         body = body.append('metadata_link', this.type_s7path);
         body = body.append('visualization_link',form.value.link);
         console.log(form.value);
       this.http.post<any>('http://ec2-54-201-120-61.us-west-2.compute.amazonaws.com:8000/api/assets/storage/',body,
          {
           headers:headers
          }
            ).subscribe(resp=>{
             console.log("storage working successful");
            },error=>{
         console.log(error.error);
         console.log('storage not working');
         });
         $("#kt_user_edit_tab_3").removeClass("active");
                $(".storage").removeClass("active");
                $("#kt_user_edit_tab_4").addClass("active");
                $(".steward").addClass("active");
         }

         onSubmit_tab5(form:NgForm){
          var headers:HttpHeaders = new HttpHeaders();
         headers=headers.append('Content-Type', 'application/x-www-form-urlencoded');
         headers=headers.append('Authorization', 'token '+this.token);
        let body: HttpParams = new HttpParams();
         body = body.append('asset', '1');
         var Objective=new Array();
         for(var i=0;i<form.value.Objective.length;i++)
         {
         Objective.push(form.value.Objective[i].value);
         }
         body = body.append('Objective', Objective.toString());
         var Sourcing=new Array();
         for(var i=0;i<form.value.Sourcing.length;i++)
         {
         Sourcing.push(form.value.Sourcing[i].value);
         }
         body = body.append('sourcing', Sourcing.toString());
         body = body.append('description', form.value.description);
         body = body.append('currency',form.value.currency );
         body = body.append('price', form.value.estimated_price);
       this.http.post<any>('http://ec2-54-201-120-61.us-west-2.compute.amazonaws.com:8000/api/assets/additional/',body,
          {
           headers:headers
          }
            ).subscribe(resp=>{
             console.log("license working successful");
            },error=>{
         console.log(error.error);
         console.log('license not working');
         });

         }
}
